<template>
  <div class="page">
    <div class="header">
      人脸识别
    </div>
    <!--    <div class="text">{{session}}</div>-->
    <!--    <div class="text">________________________________________</div>-->
    <div class="re-image">
      <img src="static/img/r_success.png" v-if="reStatus==1" style="width: 100%;height: 100%" alt="">
      <img src="static/img/r_fall.png" v-if="reStatus==2||reStatus==3" style="width: 100%;height: 100%" alt="">
      <img src="static/img/r_error.png" v-if="reStatus==4" style="width: 100%;height: 100%" alt="">
    </div>
    <div class="re-state" >{{ statusText }}</div>
    <!--    <div class="text">原因 ：人脸验证结果{{sessionResult.is_liveness?'通过':'未通过'}}</div>-->
    <div v-if="reStatus==2" class="text">人脸验证失败，请重新验证</div>
    <div v-if="reStatus>1" class="text">失败原因：{{ fallText }}</div>
    <div v-if="reStatus>1" class="text2" >
      人脸识别认证失败，识别认证需保单被保险人操作，识别超过3次则理赔流程失效，需重新查勘理赔，请
      确认是否重新认证
    </div>
    <div class="btn"  v-if="reStatus>1" @click="reFace()">重新验证</div>
    <div class="btn" v-if="reStatus==1" @click="next()">下一步</div>
  </div>
</template>

<script>
var obj = require("@/api/api.js");
export default {
  name: "face",
  data(){
    return{
      systemOs:'',
      session:'',
      reStatus:0, // 0 无  1成功  2活体验证失败  3实人认证失败  4接口异常
      statusText:'',
      sessionResult: '',
      fallText:'',
      success:false,
      registno:'',
      type:'',
    }
  },
  created() {
    console.log(this.$route.query)
    this.registno = this.$route.query.businessno
    this.type =  this.$route.query.type
    this.session = this.$cookie.get('session_id')
    this.queryResult()
  },
  methods:{
    reFace(){
      this.$router.push({path:'/face/face',query:{
          registno:this.registno,
          type:this.type,
        }})
    },
    verifyconfirm(){
      let param = {
        "businessno": this.registno,
      }
      this.$http
        .post(obj.verifyconfirm, param).then((res) => {
      })
    },
    next(){
        this.$router.push({path:'/face/clamInfo',query:{
            registno:this.registno,
            type:this.type
          }})

    },
    queryResult(){
      let _this = this
      let param = {
        // id:this.$cookie.get('session_id'),
        registno:this.registno
      }
      this.$http
        .post(obj.faceIdentifyResult, param).then((res) => {
        if( res.data.rtnCode=='0000'){
          let _res = res.data.resString
          _res = JSON.parse(_res)
          console.log(_res)
          this.sessionResult = _res.session_result
          console.log(this.sessionResult)
          if(this.sessionResult.is_liveness){ //活体验证成功
            if(this.sessionResult.verify_result&&this.sessionResult.verify_result=='MATCH'){
              this.reStatus = 1
              this.statusText = '验证成功'
            }else{
              this.reStatus = 3
              this.statusText = '验证失败'
              switch (this.sessionResult.verify_result){
                // case 'MATCH':this.fallText ='身份证等信息核验匹配，通过核验；';break;
                case 'INVALID_IDCARD_INFO':this.fallText ='身份信息无效，包括:姓名与身份证号不匹配，身份信息无效，证件挂失；';break;
                case 'FACE_UNMATCH':this.fallText ='人脸比对不匹配';break;
                default:this.fallText ='未知原因身份验证失败';break;
              }
              this.verifyconfirm()
            }
          }else{//活体验证失败
            this.reStatus = 2
            this.statusText = '验证失败'
            switch (this.sessionResult.details.liveness_failed_reason){
              case 'colorful liveness not passed':this.fallText ='炫彩检测不通过，面部反射光太弱，可尝试调亮屏幕亮度';break;
              case 'silent liveness not passed':this.fallText ='静默活体不通过，请勿佩戴奇异配饰或手持身份证';break;
              case 'colorful light with env highlight':this.fallText ='环境光不符合要求，一般是存在强光源或屏幕亮度过低';break;
              case 'colorful light not passed':this.fallText ='炫彩序列校验不通过，请调亮屏幕亮度重试';break;
              case 'defake not passed':this.fallText ='深伪检测不通过';break;
              case 'frame validity failed':this.fallText ='设备被风控，可能存在劫持、注入等攻击';break;
              case 'hack':this.fallText ='视频录制活体检测不通过，疑似假造人脸 比如视频拍摄的是照片';break;
              case 'short_time':this.fallText ='视频录制活体检测不通过，视频中连续有同一完整人脸的时长不足2秒';break;
              case 'motion_failed':this.fallText ='视频录制活体检测不通过，动作序列检测未通过';break;
              case 'no_face_detected':this.fallText ='视频录制活体检测不通过，视频中未检测到人脸';break;
              default:this.fallText ='未知原因验证失败';break;
            }
            this.verifyconfirm()
            // this.fallText =
          }
        }else if(res.data.rtnCode=='9999'){
          this.reStatus = 4
          this.statusText = '验证异常'
          this.fallText =res.data.rtnMsg
        }else{
          this.reStatus = 4
          this.statusText = '验证异常'
          this.fallText ='获取结果接口异常'
        }

        // colorful liveness not passed:炫彩检测不通过，面部反射光太弱，可尝试调亮屏幕亮度
        // silent liveness not passed:静默活体不通过，请勿佩戴奇异配饰或手持身份证
        // colorful light with env highlight:环境光不符合要求，一般是存在强光源或屏幕亮度过低
        // colorful light not passed:炫彩序列校验不通过，请调亮屏幕亮度重试
        // defake not passed:深伪检测不通过
        // frame validity failed 设备被风控，可能存在劫持、注入等攻击
        // hack:视频录制活体检测不通过，疑似假造人脸 比如视频拍摄的是照片
        // short_time:视频录制活体检测不通过，视频中连续有同一完整人脸的时长不足2秒
        // motion_failed:视频录制活体检测不通过，动作序列检测未通过
        // no_face_detected:视频录制活体检测不通过，视频中未检测到人脸

        //         身份核验结果。
        // MATCH：身份证等信息核验匹配，通过核验；
        // INVALID_IDCARD_INFO：身份信息无效，包括:姓名与身份证号不匹配，身份信息无效，证件挂失；
        // FACE_UNMATCH：人脸比对不匹配
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.page{
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  .text{
    font-size: 14px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
    color: red;
  }
  .text2{
    font-size: 14px;
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    color: black;
  }
  .header{
    width: 100vw;
    height: 40px;
    background-color: #00a74c;
    text-align: center;
    font-size: 16px;
    line-height: 40px;
    color: white;
  }
  .re-image{
    width: 150px;
    height: 150px;
    margin-left: calc((100vw - 150px) / 2);
    //background-color: #666666;
    margin-top: 60px;
  }
  .re-state{
    width: 200px;
    height: 40px;
    text-align: center;
    margin-left: calc((100vw - 200px) / 2);
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
  }
}
.btn{
  width: 98vw;
  margin-left: 1vw;
  height: 60px;
  background-color: #05c95e;
  text-align: center;
  font-size: 16px;
  line-height: 60px;
  color: white;
  margin-top: 30px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/face/faceEnd.vue